import { createSvgIcon } from "@mui/material";

export const FolderNotch = createSvgIcon(
  <svg width="16" height="16" viewBox="0 0 16 16" fill="#000" xmlns="http://www.w3.org/2000/svg">
    <g id="FolderNotch">
      <path
        id="Vector"
        d="M13.5 4.5H8.16687L6.43313 3.2C6.25978 3.07066 6.04941 3.00054 5.83313 3H2.5C2.23478 3 1.98043 3.10536 1.79289 3.29289C1.60536 3.48043 1.5 3.73478 1.5 4V12.5C1.5 12.7652 1.60536 13.0196 1.79289 13.2071C1.98043 13.3946 2.23478 13.5 2.5 13.5H13.5C13.7652 13.5 14.0196 13.3946 14.2071 13.2071C14.3946 13.0196 14.5 12.7652 14.5 12.5V5.5C14.5 5.23478 14.3946 4.98043 14.2071 4.79289C14.0196 4.60536 13.7652 4.5 13.5 4.5ZM2.5 4H5.83313L7.16687 5L5.83313 6H2.5V4ZM13.5 12.5H2.5V7H5.83313C6.04941 6.99946 6.25978 6.92934 6.43313 6.8L8.16687 5.5H13.5V12.5Z"
      />
    </g>
  </svg>,
  "Folder Notch Icon"
);
